<template>
  <div class="hvh-flex h-100" v-if="showMenu && !$route.path.startsWith('/Account/')">
    <FixedPlaceholder :component="ScipherLeftMenu" />
    <div class="hvh-flex grow-1 overflow-hidden">
      <slot name="menu" />
      <div class="hvh-flex column grow-1 overflow-hidden">
        <slot />
      </div>
    </div>
  </div>
  <v-content :class="isFullScreen ? 'pt-3 ma-0' : ''" v-else>
    <slot />
  </v-content>
</template>

<script>
import FixedPlaceholder from '../../common/fixedPlaceholder/FixedPlaceholder.vue';
import ScipherLeftMenu from '../layout/ScipherLeftMenu.vue';
export default {
  components: { FixedPlaceholder, },
  props: ['isActics', 'isFullScreen'],
  data() {
    return {
      ScipherLeftMenu
    };
  },
  computed: {
    showMenu() {
      return this.isActics !== false;
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisScipherLayout'] = this;
  },
}
</script>

<style lang="scss" scoped>
.new-cohort {
  background-color: #666adf;
}

.left-menu {
  background-color: #e6f6f8;
  min-height: 100%;

  .icon {
    font-size: 16px;

    &.pin {
      transform: rotate(45deg);
    }
  }

  button {
    padding: 8px 10px;
    border-radius: 7px;
    background-color: #666adf;
    color: white;
    font-size: 14px;
    width: 100%;
  }
}
</style>